export default __webpack_public_path__ + "static/media/campaign.7cf0c372.svg";